<template>
  <v-form>
    <v-container>
      <div style="height: 10px;"></div>

      <div style="font-size: 20px;">{{ selectedStore.storeName }}</div>

      <div style="height: 30px;"></div>

      <div style="font-size: 20px;">{{ $t('sales.store-arrival-day') }}: {{ this.shippingDate }}</div>

      <div style="height: 30px;"></div>

      <div style="height: 40px;"></div>

      <v-data-table :headers="headers" :items="selectedOrderItems" hide-actions class="elevation-1">
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <span v-on="on">{{ props.header.text }}</span>
            </template>
            <span>{{ props.header.text }}</span>
          </v-tooltip>
        </template>
        <template v-slot:items="props">
          <td class="text-xs-left">{{ props.item.itemCategoryName }}</td>
          <td class="text-xs-left">{{ props.item.itemName }}</td>
          <td class="text-xs-right">{{ props.item.quantity }}</td>
        </template>
      </v-data-table>

      <v-flex xs12 sm12>
        <div style="height: 30px;"></div>
      </v-flex>

      <v-flex xs12 sm12>
        <v-textarea outline v-model="remarks" :label="$t('sales.order-remarks')" disabled></v-textarea>
      </v-flex>

      <div style="height: 35px;"></div>

      <v-layout row wrap>
        <v-flex xs12 sm6>
          <v-btn
            block
            color="error"
            :loading="loading"
            :disabled="loading"
            @click="sendOrder()"
          >{{ $t('sales.request-order-btn') }}</v-btn>
        </v-flex>
        <v-flex xs12 sm6>
          <v-btn
            block
            color="#4C728A"
            dark
            :to="{
              name: 'sales/new-order-send',
              params: { fromOrderSendConfirm: true }
            }"
          >{{ $t('sales.modify-btn') }}</v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </v-form>
</template>

<script>
import { mapState } from 'vuex'
import ServerApiCallService from '@/services/ServerApiCallService.js'
export default {
  created() {
    console.log('created')
    ServerApiCallService.setAppJs(this.$parent.$parent.$parent)

    this.$store.commit('SET_ORDER_DISP_ADD_ORDER_FORM', true)
  },
  methods: {
    sendOrder() {
      console.log('send order')
      this.loading = true

      let request = {
        shippingDate: this.shippingDate.replace(/\//g, ''),
        storeCode: this.selectedStore.storeCode,
        orderItems: this.selectedOrderItems,
        remarks: this.remarks
      }

      let sendContext = {
        hasDialogComponent: this.$parent.$parent.$parent,
        forwardNameOnClose: 'sales/new-user-menu'
      }

      ServerApiCallService.sendOrder(request, sendContext)
        .then(response => {})
        .catch(error => {
          console.log('There was an error:', error.response)
          this.loading = false
        })
    }
  },
  computed: {
    ...mapState({
      user: state => state.user,
      selectedStore: state => state.salesSession.menuSelectedStore
    }),
    shippingDate: {
      get() {
        return this.$store.state.salesSession.orderSelectedShippingDate
      },
      set(value) {
        this.$store.commit('SET_ORDER_SELECTED_SHIPPING_DATE', value)
      }
    },
    selectedOrderItems: {
      get() {
        return this.$store.state.salesSession.orderSelectedOrderItems
      },
      set(value) {
        this.$store.commit('SET_ORDER_SELECTED_ITEMS', value)
      }
    },
    remarks: {
      get() {
        return this.$store.state.salesSession.remarks
      },
      set(value) {
        this.$store.commit('SET_ORDER_REMARKS', value)
      }
    }
  },
  data() {
    return {
      loading: false,
      date: '', // new Date().toISOString().substr(0, 10)
      menu: false,
      modal: false,
      menu2: false,
      headers: [
        {
          text: this.$t('sales.table-header-item-category'),
          align: 'left',
          sortable: false,
          value: 'itemCategoryName',
          width: '20%',
          fixed: true
        },
        {
          text: this.$t('sales.product-name'),
          align: 'left',
          value: 'itemName',
          sortable: false,
          width: '75%',
          fixed: true
        },
        {
          text: this.$t('sales.quantity'),
          align: 'right',
          sortable: false,
          value: 'fat',
          width: '15%',
          fixed: true
        }
      ]
    }
  }
}
</script>

<style></style>
